import { Group } from '../types';

export enum CampaignScopeType {
  NETWORK = 'NETWORK',
  GROUP = 'GROUP',
  MULTI_TENANT_ORGANIZATION = 'MULTI_TENANT_ORGANIZATION',
}

export interface BaseCampaignScope {
  readonly type: CampaignScopeType;
}

export interface CampaignGroupScope extends BaseCampaignScope {
  readonly type: CampaignScopeType.GROUP;
  readonly groupId: Group['id'];
}

export interface CampaignNetworkScope extends BaseCampaignScope {
  readonly type: CampaignScopeType.NETWORK;
  readonly isNetworkScopedCampaign: boolean;
}
export interface CampaignMultiTenantOrganizationScope extends BaseCampaignScope {
  readonly type: CampaignScopeType.MULTI_TENANT_ORGANIZATION;
  readonly isMultiTenantOrganizationScopedCampaign: boolean;
}

export type CampaignScope = CampaignGroupScope | CampaignNetworkScope | CampaignMultiTenantOrganizationScope;
